import { connectHits } from 'instantsearch.js/es/connectors';

/**
 * Recupère le contenu de l'encart dans le DOM, afin d'avoir les texetes traduits
 * @return {object}
 */
function getEncartContenu() {
  let contact = $('.contenuPage').data('encart-contact');
  let title = $('.contenuPage').data('encart-title');
  let text = $('.contenuPage').data('encart-text');
  let url = $('.contenuPage').data('contact-url');

  return {
    contact,
    title,
    text,
    url,
  };
}

function getEncart() {
  let encartContenu = getEncartContenu();
  return `<li class="ais-InfiniteHits-item ais-InfiniteHits-item--contact">
              <div class="card card--produit">
                <div class="card-content">
                      <h4 class="card-title titre5">${encartContenu.title ? encartContenu.title : ''}</h4>
                      <span class="tip">${encartContenu.text ? encartContenu.text : ''}</span>
                  </div>
                  <div class="card-footer">
                      <a href="${
                        encartContenu.url ? encartContenu.url : ''
                      }" class="btn btn-block btn-sm btn-outline-primary">
                        ${encartContenu.contact ? encartContenu.contact : ''}
                      </a>
                  </div>
              </div>
          </li>`;
}

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams, results } = renderOptions;

  widgetParams.container.innerHTML = `
      <ul class="ais-InfiniteHits-list grilleProduits">
        ${hits
          .map((item) => {
            let volume = item.volume.find((element) => {
              if (element.includes('E-boutique') && $('html').attr('lang') === 'fr') {
                return true;
              }
            });
            return `<li class="ais-InfiniteHits-item">
                ${volume !== undefined ? `<span class="">${volume.split(': ')[1]}</span>` : ''}
                <a class="card card--produit" href="${item.ficheUrl}">
                    <div class="card-header">
                        <span class="tag">${item.categories}</span>
                    </div>
                    <div class="card-image">
                        ${item.image ? `<figure style="background-image: url('${item.image}');"></figure>` : ''}
                    </div>
                    <div class="card-content">
                      ${item.nom_com_court ? `<h3 class="card-title titre5">${item.nom_com_court}</h3>` : ''}
                      ${item.pays ? `<span class="tip">${item.pays.join(', ')}</span>` : ''}
                      ${item.logoMIF ? `<img src="${item.logoMIF}" class="card-mif" alt="Made in France" />` : ''}
                    </div>
                </a>
              </li>`;
          })
          .join('')}
          ${
            (results !== undefined && results.nbPages === results.page + 1) || hits.length === 0 // encart afficher à la dernière page
              ? getEncart()
              : ''
          }
      </ul>
    `;
};

const customHits = connectHits(renderHits);

export default customHits;
